import {Component, computed, input, output, signal} from '@angular/core';
import {IconConfirmDialogComponent} from '../../../../dialog/icon-confirm-dialog/icon-confirm-dialog.component';
import {ModelFieldDatepickerComponent} from '../../../../inputs/model-field/model-field-datepicker/model-field-datepicker.component';
import {addDays, createTomorrow, parseLocalDate} from '../../../../../utils/date-utils';

@Component({
  selector: 'app-update-submission-date-button',
  imports: [IconConfirmDialogComponent, ModelFieldDatepickerComponent],
  templateUrl: './update-submission-date-button.component.html',
})
export class UpdateSubmissionDateButtonComponent {
  readonly currentSubmissionDate = input.required<string>();

  readonly updateSubmissionDate = output<Date>();

  protected readonly selectedDate = signal<Date | null>(null);

  protected readonly minDate = computed(() => {
    const dayAfterCurrent = addDays(parseLocalDate(this.currentSubmissionDate()), 1);
    const tomorrow = createTomorrow();
    return dayAfterCurrent < tomorrow ? tomorrow : dayAfterCurrent;
  });

  protected onOpened(): void {
    this.selectedDate.set(this.minDate());
  }

  protected confirm(): void {
    const date = this.selectedDate();
    if (!date) {
      return;
    }
    this.updateSubmissionDate.emit(date);
  }
}
